import dayjs from "dayjs";
import { useEffect, useState } from "react";

export default function TimeWrapper() {
  const [currentTime, setCurrentTime] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(dayjs());
    }, 30 * 1000); // Update every 30 seconds

    return () => clearInterval(timer); // Cleanup on unmount
  }, []);

  return (
    <div className="timeWrapper">
      <span>Today</span>
      <div style={{ whiteSpace: "nowrap" }}>{currentTime.format("h:mm A")}</div>
    </div>
  );
}
